import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, getDocs, getDoc, doc, query, where, updateDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAi-Bniovd3eOMDGxxv7au48w0TEqHngGo",
  authDomain: "johntour-11b7a.firebaseapp.com",
  projectId: "johntour-11b7a",
  storageBucket: "johntour-11b7a.firebasestorage.app",
  messagingSenderId: "624639862793",
  appId: "1:624639862793:web:7fc8dff6e80a4ebf0ab0d8"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export function addItem(table, data){
  return new Promise((resolve, reject) => {
    addDoc(collection(db, String(table)), data)
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function getItems(table){
  return new Promise((resolve, reject) => {
    getDocs(collection(db, String(table)))
      .then(data => {
        let arrayList =[];
        data.forEach(item => {
          arrayList.push({ id: item.id, ...item.data() });
          resolve(arrayList);
        })
      })
      .catch(err => {
        reject(err)
      })
  })
}


